var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.price && !this.price.hidden
    ? _c(
        "div",
        [
          ["option", "available", "under_contract"].includes(_vm.status)
            ? [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.computedPrice) }
                })
              ]
            : _vm.status === "sold"
            ? _c(
                "span",
                { staticClass: "text-20 lg:text-24", class: _vm.labelClass },
                [_vm._v(_vm._s(_vm.$t("sweepbright.sold")))]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }